import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Button } from 'react-bootstrap'
import * as s from './EliminatorEnterPickGame.scss'
import NflTeamListItem from '../Football/NflTeamListItem'
import moment from 'moment-timezone'
import { animateScroll } from 'react-scroll'
import numeral from 'numeral'
import FontAwesome from 'react-fontawesome'

const GameButtonContainer = ({ isPicked, teamId, teamName, city, mascot, record, chancesOfWinning = 0.00, onClick = null }) => (
<div className={s.gameButtonContainer}>
    <NflTeamListItem className={s.gameButton + ` ${(isPicked ? s.isPicked : s.isNotPicked)}`}
        teamId={teamId} teamName={teamName}
        city={city} mascot={mascot} record={record} 
        right={chancesOfWinning ? <div className={s.chancesOfWinning} title={`${mascot} estimated chance of winning: ${numeral(chancesOfWinning).format('0.0%')}`}>{numeral(chancesOfWinning).format('0%')}</div> : null}
        highlightOnHover
        disabled={isPicked} onClick={() => onClick(teamId)} />
</div>
)

const EliminatorEnterPickGame = ({ game = {}, index = -1, savePick = () => alert('!') }) => {

    const hasProbabilities = [game.visitorChancesOfWinning, game.homeChancesOfWinning]
        .every(value => Number.isFinite(value) && value >= 0 && value <= 1) &&
        game.visitorChancesOfWinning + game.homeChancesOfWinning > 0

    const makePick = teamId => {
        savePick(teamId)
        animateScroll.scrollToTop()
    }

    return (
        <div className={s.container}>
            <GameButtonContainer teamId={game.visitor} teamName={game.visitorTeam} 
                city={game.visitorCity}
                mascot={game.visitorMascot} record={game.visitorRecord} 
                isPicked={game.pickedVisitor} 
                chancesOfWinning={game.visitorChancesOfWinning}
                onClick={() => makePick(game.visitor)} />
            <div className={s.atContainer}>
                {hasProbabilities ?
                    <div className={s.chancesOfWinningContainer + (game.visitorChancesOfWinning > game.homeChancesOfWinning ? ` ${s.flip}` : ``)}>
                        <div className={s.visitorChancesOfWinning} style={{ width: `${game.visitorChancesOfWinning * 100.0}%` }} title={`${game.visitorMascot} estimated chance of winning: ${numeral(game.visitorChancesOfWinning).format('0.0%')}`}>&nbsp;</div>
                        <div className={s.homeChancesOfWinning} style={{ width: `${game.homeChancesOfWinning * 100.0}%` }} title={`${game.homeMascot} estimated chance of winning: ${numeral(game.homeChancesOfWinning).format('0.0%')}`}>&nbsp;</div>
                    </div>
                : null}
                <div className={s.atCharacter}><FontAwesome name='at' size='2x' /></div>
            </div>
            <GameButtonContainer teamId={game.home} teamName={game.homeTeam} 
                city={game.homeCity}
                mascot={game.homeMascot} record={game.homeRecord} 
                isPicked={game.pickedHome} 
                chancesOfWinning={game.homeChancesOfWinning}
                onClick={() => makePick(game.home)} />
            <div className={s.gameTime}>{moment(game.date).format('h:mm A')}</div>
        </div>
    )
}

export default EliminatorEnterPickGame
